export default __webpack_public_path__ + "static/media/icon-https.42f84b9c.svg";